// Version : 0.0.5
// Author : VISHNU
// LastEdit : KARTHEESWARAN
// LastAdd  : DESTRUCTURING PAYLOAD VALUES
// MODFIED DATA : 13-08-2025
import { call, takeLatest, put, all } from 'redux-saga/effects';

import {
	GSTTypeDetailsAdd,
	GSTTypeDetailsDelete,
	GSTTypeDetailsFetch,
	GSTTypeDetailsUpdate,
	GSTTypeListGet,
} from './gstType.service';
import {
	// ADD GST TYPE DETAILS
	addGSTTypeDetailsFailure,
	addGSTTypeDetailsResponseChanged,
	addGSTTypeDetailsSuccess,
	// DELETE GST TYPE DETAILS
	deleteGSTTypeDetailsFailure,
	deleteGSTTypeDetailsResponseChanged,
	deleteGSTTypeDetailsSuccess,
	// FETCH GST TYPE DETAILS
	fetchGSTTypeDetailsFailure,
	fetchGSTTypeDetailsResponseChanged,
	fetchGSTTypeDetailsSuccess,
	// GET GST TYPE LIST
	getGSTTypeListFailure,
	getGSTTypeListResponseChanged,
	getGSTTypeListSuccess,
	// UPDATE GST TYPE DETAILS
	updateGSTTypeDetailsFailure,
	updateGSTTypeDetailsResponseChanged,
	updateGSTTypeDetailsSuccess,
} from './gstType.action';
import GSTTypeActionTypes from './gstType.types';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** ***************** ADD GST TYPE DETAILS START *********************** */
export function* addGSTTypeDetails({ payload }: any) {
	try {
		const {
			infogCompanyID,
			partyIsActive,
			partyGstTypeID,
			partyGstTypeName,
			userID,
			userName,
			databaseName,
		} = payload;
		const key = 'AddGSTTypeDetailsKey';
		const jsonData = {
			InfogID: infogCompanyID,
			PartyIsActive: partyIsActive,
			PartyGstTypeID: partyGstTypeID,
			PartyGstTypeName: partyGstTypeName,
			CreatedBy: userID,
			UserName: userName,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(GSTTypeDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addGSTTypeDetailsFailure(responseData.data));
		} else {
			yield put(addGSTTypeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addGSTTypeDetailsFailure(error));
	}
}

export function* resetAddGSTTypeDetailsResponse() {
	yield put(addGSTTypeDetailsResponseChanged());
}

export function* onAddGSTTypeDetails() {
	yield takeLatest(GSTTypeActionTypes.ADD_GST_TYPE_DETAILS_START, addGSTTypeDetails);
}

export function* onAddGSTTypeDetailsResponseReset() {
	yield takeLatest(
		GSTTypeActionTypes.ADD_GST_TYPE_DETAILS_RESPONSE_RESET,
		resetAddGSTTypeDetailsResponse,
	);
}
/** ***************** ADD GST TYPE DETAILS END *********************** */

/** ***************** UPDATE GST TYPE DETAILS START *********************** */
export function* updateGSTTypeDetails({ payload }: any) {
	try {
		const {
			infogCompanyID,
			partyIsActive,
			partyGstTypeID,
			partyGstTypeName,
			userID,
			userName,
			databaseName,
		} = payload;
		const key = 'UpdateGSTTypeDetailsKey';
		const jsonData = {
			InfogID: infogCompanyID,
			PartyIsActive: partyIsActive,
			PartyGstTypeID: partyGstTypeID,
			PartyGstTypeName: partyGstTypeName,
			CreatedBy: userID,
			UserName: userName,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(GSTTypeDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateGSTTypeDetailsFailure(responseData.data));
		} else {
			yield put(updateGSTTypeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateGSTTypeDetailsFailure(error));
	}
}

export function* resetUpdateGSTTypeDetailsResponse() {
	yield put(updateGSTTypeDetailsResponseChanged());
}

export function* onUpdateGSTTypeDetails() {
	yield takeLatest(GSTTypeActionTypes.UPDATE_GST_TYPE_DETAILS_START, updateGSTTypeDetails);
}

export function* onUpdateGSTTypeDetailsResponseReset() {
	yield takeLatest(
		GSTTypeActionTypes.UPDATE_GST_TYPE_DETAILS_RESPONSE_RESET,
		resetUpdateGSTTypeDetailsResponse,
	);
}
/** ***************** UPDATE GST TYPE DETAILS END *********************** */

/** ***************** GET GST TYPE LIST START *********************** */
export function* getGSTTypeList({ payload }: any) {
	try {
		const { infogCompanyID, inputSearch, limit, databaseName } = payload;
		const key = 'GetGSTTypeListKey';
		const jsonData = {
			InfogID: infogCompanyID,
			InputSearch: inputSearch,
			DatabaseName: databaseName,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(GSTTypeListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getGSTTypeListFailure(responseData.data));
		} else {
			yield put(getGSTTypeListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getGSTTypeListFailure(error));
	}
}

export function* resetGetGSTTypeListResponse() {
	yield put(getGSTTypeListResponseChanged());
}

export function* onGetGSTTypeList() {
	yield takeLatest(GSTTypeActionTypes.GET_GST_TYPE_LIST_START, getGSTTypeList);
}

export function* onGetGSTTypeListResponseReset() {
	yield takeLatest(
		GSTTypeActionTypes.GET_GST_TYPE_LIST_RESPONSE_RESET,
		resetGetGSTTypeListResponse,
	);
}
/** ***************** GET GST TYPE LIST END *********************** */

/** ***************** FETCH GST TYPE DETAILS START *********************** */
export function* fetchGSTTypeDetails({ payload }: any) {
	try {
		const { infogCompanyID, partyGstTypeID, databaseName } = payload;
		const key = 'FetchGSTTypeDetailsKey';
		const jsonData = {
			InfogID: infogCompanyID,
			PartyGstTypeID: partyGstTypeID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(GSTTypeDetailsFetch, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchGSTTypeDetailsFailure(responseData.data));
		} else {
			yield put(fetchGSTTypeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGSTTypeDetailsFailure(error));
	}
}

export function* resetFetchGSTTypeDetailsResponse() {
	yield put(fetchGSTTypeDetailsResponseChanged());
}

export function* onFetchGSTTypeDetails() {
	yield takeLatest(GSTTypeActionTypes.FETCH_GST_TYPE_DETAILS_START, fetchGSTTypeDetails);
}

export function* onFetchGSTTypeDetailsResponseReset() {
	yield takeLatest(
		GSTTypeActionTypes.FETCH_GST_TYPE_DETAILS_RESPONSE_RESET,
		resetFetchGSTTypeDetailsResponse,
	);
}
/** ***************** FETCH GST TYPE DETAILS END *********************** */

/** ***************** DELETE GST TYPE DETAILS START *********************** */
export function* deteleGSTTypeDetails({ payload }: any) {
	try {
		const { infogCompanyID, partyGstTypeID, userID, userName, databaseName } = payload;
		const key = 'DeleteGstTypeDetailsKey';
		const jsonData = {
			InfogID: infogCompanyID,
			PartyGstTypeID: partyGstTypeID,
			CreatedBy: userID,
			UserName: userName,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(GSTTypeDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteGSTTypeDetailsFailure(responseData.data));
		} else {
			yield put(deleteGSTTypeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteGSTTypeDetailsFailure(error));
	}
}

export function* resetDeleteGSTTypeDetailsResponse() {
	yield put(deleteGSTTypeDetailsResponseChanged());
}

export function* onDeleteGSTTypeDetails() {
	yield takeLatest(GSTTypeActionTypes.DELETE_GST_TYPE_DETAILS_START, deteleGSTTypeDetails);
}

export function* onDeleteGSTTypeDetailsResponseReset() {
	yield takeLatest(
		GSTTypeActionTypes.DELETE_GST_TYPE_DETAILS_RESPONSE_RESET,
		resetDeleteGSTTypeDetailsResponse,
	);
}
/** ***************** DELETE GST TYPE DETAILS END *********************** */

export function* gstTypeFinanceSaga() {
	yield all([
		// ADD GST TYPE DETAILS
		call(onAddGSTTypeDetails),
		call(onAddGSTTypeDetailsResponseReset),
		// UPDATE GST TYPE DETAILS
		call(onUpdateGSTTypeDetails),
		call(onUpdateGSTTypeDetailsResponseReset),
		// GET GST TYPE LIST
		call(onGetGSTTypeList),
		call(onGetGSTTypeListResponseReset),
		// FETCH GST TYPE DETAILS
		call(onFetchGSTTypeDetails),
		call(onFetchGSTTypeDetailsResponseReset),
		// DELETE GST TYPE DETAILS
		call(onDeleteGSTTypeDetails),
		call(onDeleteGSTTypeDetailsResponseReset),
	]);
}
